
export const data = [
  {
    Category: 'Add-Ons',
    'Subscription ID': 29033,
    'Subscription Plan': 'MS Corporate Monthly-Office 365',
    Item: 'Monthly-CFQ7TTC0LHS9',
    'Item Description Line 2': 'Office 365 Extra File Storage',
    Cost: 0.26,
    Price: 0.32
  },
  {
    Category: 'Add-Ons',
    'Subscription ID': 29033,
    'Subscription Plan': 'MS Corporate Monthly-Office 365',
    Item: 'Monthly-CFQ7TTC0LHSW',
    'Item Description Line 2': 'Office 365 Data Loss Prevention',
    Cost: 3.94,
    Price: 4.92
  },
  {
    Category: 'Add-Ons',
    'Subscription ID': 28921,
    'Subscription Plan': 'Microsoft Corporate Monthly-Azure',
    Item: 'Monthly-CFQ7TTC0LH9J',
    'Item Description Line 2': 'Azure Information Protection Premium P1',
    Cost: 2.59,
    Price: 3.24
  },
  {
    Category: 'Add-Ons',
    'Subscription ID': 28921,
    'Subscription Plan': 'Microsoft Corporate Monthly-Azure',
    Item: 'Monthly-CFQ7TTC0LFLS',
    'Item Description Line 2': 'Microsoft Entra ID P1',
    Cost: 7.78,
    Price: 9.72
  },
  {
    Category: 'Add-Ons',
    'Subscription ID': 28921,
    'Subscription Plan': 'Microsoft Corporate Monthly-Azure',
    Item: 'Monthly-CFQ7TTC0LFK5',
    'Item Description Line 2': 'Microsoft Entra ID P2',
    Cost: 11.71,
    Price: 16.64
  },
  {
    Category: 'Business',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly - CFQ7TTC0LH18',
    'Item Description Line 2': 'Microsoft 365 Business Basic',
    Cost: 7.78,
    Price: 9.72
  },
  {
    Category: 'Business',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly - CFQ7TTC0LCHC',
    'Item Description Line 2': 'Microsoft 365 Business Premium',
    Cost: 28.61,
    Price: 35.76
  },
  {
    Category: 'Business',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly - CFQ7TTC0LDPB',
    'Item Description Line 2': 'Microsoft 365 Business Standard',
    Cost: 16.32,
    Price: 20.4
  },
  {
    Category: 'Business',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly - CFQ7TTC0LH1G',
    'Item Description Line 2': 'Microsoft 365 Apps for business',
    Cost: 11.23,
    Price: 14.04
  },
  {
    Category: 'Enterprise',
    'Subscription ID': 29033,
    'Subscription Plan': 'MS Corporate Monthly-Office 365',
    Item: 'Monthly - CFQ7TTC0LF8R',
    'Item Description Line 2': 'Office 365 E3',
    Cost: 31.1,
    Price: 38.88
  },
  {
    Category: 'Enterprise',
    'Subscription ID': 29033,
    'Subscription Plan': 'MS Corporate Monthly-Office 365',
    Item: 'Monthly - CFQ7TTC0LF8Q',
    'Item Description Line 2': 'Office 365 E1',
    Cost: 13.06,
    Price: 16.32
  },
  {
    Category: 'Enterprise',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly-CFQ7TTC0LHQB',
    'Item Description Line 2': 'Microsoft 365 E5 Security',
    Cost: 15.65,
    Price: 19.56
  },
  {
    Category: 'Enterprise',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly - CFQ7TTC0LGZT',
    'Item Description Line 2': 'Microsoft 365 Apps for enterprise',
    Cost: 16.32,
    Price: 20.4
  },
  {
    Category: 'Enterprise',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly-CFQ7TTC0LFLZ',
    'Item Description Line 2': 'Microsoft 365 E5',
    Cost: 74.21,
    Price: 92.76
  },
  {
    Category: 'Enterprise',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly - CFQ7TTC0LFLX',
    'Item Description Line 2': 'Microsoft 365 E3',
    Cost: 48.77,
    Price: 60.96
  },
  {
    Category: 'Exchange',
    'Subscription ID': 28925,
    'Subscription Plan': 'Microsoft Corporate Monthly-Exchange',
    Item: 'Monthly-CFQ7TTC0LH0J',
    'Item Description Line 2': 'Exchange Online Archiving for Exchange Online',
    Cost: 3.94,
    Price: 4.92
  },
  {
    Category: 'Exchange',
    'Subscription ID': 28925,
    'Subscription Plan': 'Microsoft Corporate Monthly-Exchange',
    Item: 'Monthly-CFQ7TTC0LH0L',
    'Item Description Line 2': 'Exchange Online Kiosk',
    Cost: 2.59,
    Price: 3.24
  },
  {
    Category: 'Exchange',
    'Subscription ID': 28925,
    'Subscription Plan': 'Microsoft Corporate Monthly-Exchange',
    Item: 'Monthly-CFQ7TTC0LH1P',
    'Item Description Line 2': 'Exchange Online (Plan 2)',
    Cost: 10.46,
    Price: 13.08
  },
  {
    Category: 'Exchange',
    'Subscription ID': 28925,
    'Subscription Plan': 'Microsoft Corporate Monthly-Exchange',
    Item: 'Monthly-CFQ7TTC0LH16',
    'Item Description Line 2': 'Exchange Online (Plan 1)',
    Cost: 5.18,
    Price: 6.48
  },
  {
    Category: 'Frontline',
    'Subscription ID': 29033,
    'Subscription Plan': 'MS Corporate Monthly-Office 365',
    Item: 'Monthly - CFQ7TTC0LGZW',
    'Item Description Line 2': 'Office 365 F3',
    Cost: 5.18,
    Price: 6.48
  },
  {
    Category: 'Frontline',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly - CFQ7TTC0LH05',
    'Item Description Line 2': 'Microsoft 365 F3',
    Cost: 10.46,
    Price: 13.08
  },
  {
    Category: 'Frontline',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Annual-CFQ7TTC0MBMD F5 Sec Comp',
    'Item Description Line 2': 'Microsoft 365 F5 Security + Compliance Add-on',
    Cost: 16.9,
    Price: 21.12
  },
  {
    Category: 'Frontline',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly-CFQ7TTC0MBMD Sec',
    'Item Description Line 2': 'Microsoft 365 F5 Security Add-on',
    Cost: 10.46,
    Price: 13.08
  },
  {
    Category: 'Frontline',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly-CFQ7TTC0MBMD Comp',
    'Item Description Line 2': 'Microsoft 365 F5 Compliance Add-on',
    Cost: 10.46,
    Price: 13.08
  },
  {
    Category: 'Frontline',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly - CFQ7TTC0MBMD',
    'Item Description Line 2': 'Microsoft 365 F1',
    Cost: 2.98,
    Price: 3.72
  },
  {
    Category: 'Teams',
    'Subscription ID': 264562,
    'Subscription Plan': 'Microsoft Corporate Monthly Teams - CA v.4',
    Item: 'Monthly-CFQ7TTC0HL73',
    'Item Description Line 2': 'Teams Phone with Calling Plan',
    Cost: 19.58,
    Price: 24.48
  },
  {
    Category: 'Teams',
    'Subscription ID': 264562,
    'Subscription Plan': 'Microsoft Corporate Monthly Teams - CA v.4',
    Item: 'Monthly-CFQ7TTC0JN4R',
    'Item Description Line 2': 'Microsoft Teams Essentials (AAD Identity)',
    Cost: 5.18,
    Price: 6.48
  },
  {
    Category: 'Teams',
    'Subscription ID': 264562,
    'Subscription Plan': 'Microsoft Corporate Monthly Teams - CA v.4',
    Item: 'Monthly - CFQ7TTC0QW7C',
    'Item Description Line 2': 'Microsoft Teams Rooms Pro',
    Cost: 52.13,
    Price: 65.16
  },
  {
    Category: 'Teams',
    'Subscription ID': 264562,
    'Subscription Plan': 'Microsoft Corporate Monthly Teams - CA v.4',
    Item: 'Monthly - CFQ7TTC0LH0T',
    'Item Description Line 2': 'Microsoft Teams Phone Standard',
    Cost: 10.46,
    Price: 13.08
  },
  {
    Category: 'Teams',
    'Subscription ID': 264562,
    'Subscription Plan': 'Microsoft Corporate Monthly Teams - CA v.4',
    Item: 'Monthly - CFQ7TTC0RM8K',
    'Item Description Line 2': 'Microsoft Teams Premium',
    Cost: 9.12,
    Price: 11.4
  },
  {
    Category: 'Teams',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly-CFQ7TTC0LHSL',
    'Item Description Line 2': 'Microsoft 365 Audio Conferencing',
    Cost: 4.08,
    Price: 4.08
  },
  {
    Category: 'Teams',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly-CFQ7TTC0LHXT',
    'Item Description Line 2':
      'Microsoft 365 Domestic and International Calling Plan',
    Cost: 39.12,
    Price: 39.12
  },
  {
    Category: 'Teams',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly-CFQ7TTC0LHXD',
    'Item Description Line 2':
      'Microsoft 365 International Calling Plan for SMB',
    Cost: 15.65,
    Price: 19.56
  },
  {
    Category: 'Teams',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly-CFQ7TTC0LHXJ 120min',
    'Item Description Line 2': 'Microsoft 365 Domestic Calling Plan (120 min)',
    Cost: 7.78,
    Price: 9.72
  },
  {
    Category: 'Teams',
    'Subscription ID': 22743,
    'Subscription Plan': 'Microsoft Corporate Monthly - M365',
    Item: 'Monthly-CFQ7TTC0LHXJ',
    'Item Description Line 2': 'Microsoft 365 Domestic Calling Plan',
    Cost: 19.56,
    Price: 19.56
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LDPB-NFP',
    'Item Description Line 2':
      'Microsoft 365 Business Standard (Nonprofit Staff Pricing)',
    Cost: 0,
    Price: 0
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LH18-NFP',
    'Item Description Line 2':
      'Microsoft 365 Business Basic (Nonprofit Staff Pricing)',
    Cost: 0,
    Price: 0
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LCHC-NFP',
    'Item Description Line 2':
      'Microsoft 365 Business Premium (Nonprofit Staff Pricing)',
    Cost: 8.1,
    Price: 9
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LF8Q-NFP',
    'Item Description Line 2': 'Office 365 E1 (Nonprofit Staff Pricing)',
    Cost: 3.67,
    Price: 4.08
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LFLX-NFP',
    'Item Description Line 2': 'Microsoft 365 E3 (Nonprofit Staff Pricing)',
    Cost: 13.72,
    Price: 15.24
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LH05-NFP',
    'Item Description Line 2': 'Microsoft 365 F3 (Nonprofit Staff Pricing)',
    Cost: 2.92,
    Price: 3.24
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LF8R-NFP',
    'Item Description Line 2': 'Office 365 E3 (Nonprofit Staff Pricing)',
    Cost: 8.75,
    Price: 9.72
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LFLZ-NFP',
    'Item Description Line 2': 'Microsoft 365 E5 (Nonprofit Staff Pricing)',
    Cost: 33.37,
    Price: 37.08
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LFLS-NFP',
    'Item Description Line 2': 'Microsoft Entra ID P1 (Not for Profit)',
    Cost: 2.14,
    Price: 2.4
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LH18-Donation',
    'Item Description Line 2':
      'Microsoft 365 Business Basic (Nonprofit Staff Pricing) - Donation',
    Cost: 0,
    Price: 0
  },
  {
    Category: 'NFP',
    'Subscription ID': 318632,
    'Subscription Plan': 'Microsoft Monthly NFP Licensing V.2',
    Item: 'Monthly-CFQ7TTC0LCHC-Donation',
    'Item Description Line 2':
      'Microsoft 365 Business Premium Donation (Non-Profit Pricing)',
    Cost: 0,
    Price: 0
  }
];

// Convert db data to local structure
export const convertDbToLocal = (dbData)=> {
    const localData = [];
    dbData.forEach((category) => {
      const categoryName = category.name;
      const categoryId = category.id;
  
      category.productCatalogOptions.forEach((option) => {
        const itemName = option.name;
        const optionId = option.id;
        const {subscriptionId,subscriptionPlan,subscriptionItem} = option;
        option.productCatalogPricings.forEach((pricing) => {
          const localItem = {
            Category: categoryName,
            categoryId,
            optionId,
            'Subscription ID': subscriptionId, 
            'Subscription Plan': subscriptionPlan, 
            Item: subscriptionItem, 
            'Item Description Line 2': itemName,
            Cost: pricing.cost,
            Price: pricing.onetimePrice
          };
          localData.push(localItem);
        });
      });
    });
  
    return localData;
  };
  